const autoSuggest = (router) => {
    console.log("router.query ** autoSuggest", router,);
    return fetch(`${router.isSrp ? '/activity/' : ''}api/autoSuggestActivityV2?keyword=${router.searchText}`).then((response) => response.json())
    // return fetch(`api/autoSuggestActivityV2?keyword=${router.searchText}`).then((response) => response.json())
}
export default autoSuggest;